export function successToast(component: any, key: string, params: any[] = []) {
    component.$buefy.toast.open({
        message: component.$t(key, params).toString(),
        type: 'is-success',
        position: 'is-top',
        duration: 4000,
    });
}

export function errorToast(component: any, key: string = 'error.system.error') {
    component.$buefy.toast.open({
        message: component.$t(key).toString(),
        type: 'is-warning',
        position: 'is-top',
        duration: 4000,
    });
}
